export const CPP_URL = 'https://www.homedepot.com/configurator-projects';
export const DESIGN_API_URL = 'specialorders/designs-api/designs';
export const DESIGN_STATUS_API_URL = 'specialorders/designs-api/designs/GetDesignStatusInfo';
export const DESIGN_API_KEY = '55C17F93-B7CE-4073-A4DE-2C6FAA52FC9D';
export const SEARCH_TYPE = 'svocid';
export const PRODUCT_LINE = '13';
export const DESIGN_STATUS_CREATED = 'created';
export const DESIGN_STATUS_PURCHASED = 'purchased';
export const DESIGN_STATUS_SCHEDULED = 'schedule';